import { Component, OnDestroy, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { ApiService } from 'src/app/api.service';
import { QualityGuarantee } from 'src/app/models/supplier-type';

@Component({
  selector: 'gmp-quality-guarantee',
  templateUrl: './gmp-quality-guarantee.component.html',
  styleUrls: ['./gmp-quality-guarantee.component.scss'],
})
export class GmpQualityGuaranteeComponent implements OnInit, OnDestroy {
  langSub?: Subscription;

  crop?: QualityGuarantee[];
  livestock?: QualityGuarantee[];
  aquaculture?: QualityGuarantee[];

  constructor(private api: ApiService, private translate: TranslateService) {}

  ngOnInit(): void {
    this.apiCalls();

    this.langSub = this.translate.onLangChange.subscribe(() => {
      this.apiCalls();
    });
  }

  ngOnDestroy(): void {
    this.langSub?.unsubscribe();
  }

  apiCalls() {
    this.api.getQualityGuarantees('CROPS').subscribe((value) => {
      this.crop = value as QualityGuarantee[];
    });

    this.api.getQualityGuarantees('LIVESTOCK').subscribe((value) => {
      this.livestock = value as QualityGuarantee[];
    });

    this.api.getQualityGuarantees('AQUATICS').subscribe((value) => {
      this.aquaculture = value as QualityGuarantee[];
    });
  }
}
